import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
import { NumberCellData } from "@/utils/CellsFactory";
import { computed } from "vue";

interface Props {
    value?: string | number;
    item?: any,
    data: NumberCellData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberCell',
  props: {
    value: null,
    item: null,
    data: null
  },
  setup(__props: any) {

const props = __props as {
    value?: string | number;
    item?: any,
    data: NumberCellData;
}


const getCurrency = store.getters['catalogueModule/GET_CURRENT_CURRENCY_ICON'];
const isShowDefaultCurrency = computed(() => props.data.currency && !props.data.isSymbolCurrency);
const isShowSymbolCurrency = computed(() => props.data.currency && props.data.isSymbolCurrency);

const getValue = computed(() => {
    if (typeof props.data.value === 'function') {
        return props.data.value(props.item);
    }

    // Number(undefined) даёт NaN, а NaN в русской локали печатается как «не число» —
    // строка непустая, поэтому подстраховка ниже на ней не срабатывала
    const raw = Number(props.value);
    const value = Number.isFinite(raw) ? raw : 0;
    const symbol = props.data.isSymbolSign ? (value < 0 ? '-' : '+') : '';
    const formatted = value.toLocaleString('ru-RU', {
        maximumFractionDigits: props.data.digits ?? 2,
        minimumFractionDigits: props.data.digits ?? 2,
    }) || '0,00';

    return `${symbol}${formatted}`;
});

const getClasses = computed(() => {
    const classes = {
        [`--${getColor.value}`]: !!getColor.value,
        '--mono': props.data.isMono,
        '--no-wrap': props.data.noWrap,
    };
    return Object.keys(classes).filter((key) => classes[key]).join(' ');
});

const getColor = computed(() => {
    if (typeof props.data.color === 'function') {
        return props.data.color(props.item);
    }
    return props.data.color;
});

const getDefaultCurrency = computed(() => {
    if (typeof props.data.currency === 'function') {
        return props.data.currency(props.item);
    }

    return props.data.currency;
});

return { __sfc: true,props, getCurrency, isShowDefaultCurrency, isShowSymbolCurrency, getValue, getClasses, getColor, getDefaultCurrency }
}

})